import { AI_API_SERVICE } from '@eggplant/api-hosts'
import { AuthenticatedDataRequest } from '@eggplant/data-request'
import type { Error } from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  onError?: (error: Error) => void
  onSuccess?: () => void
  children?: () => ReactElement
  shortErrorMessage?: string
  id: string
}

const DeleteAiModelRequest = ({
  onError,
  onSuccess,
  children,
  shortErrorMessage,
  id
}: Props) => {
  const url = `${AI_API_SERVICE}/models/${id}`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='delete'
      onError={onError}
      onSuccess={onSuccess}
      shortErrorMessage={shortErrorMessage}
      url={url}
    />
  )
}

export default DeleteAiModelRequest
